import { colors, cssThemedValue, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { HeartIcon } from './HeartIcon';
import YuhoPlaceholder from './images/yuho_placeholder.png';

export type VenuePreviewCardProps = {
  name: string;
  description?: string;
  imageUrl?: string | null;
};

const StyledRoot = styled.div`
  border-radius: 8px;
  margin: 0 16px 16px;
  box-shadow: 0 2px 2px 0 ${cssThemedValue({ light: colors.pepper12, dark: colors.salt12 })};
  overflow: hidden;
`;

const ImageContainer = styled.div`
  position: relative;
`;

const StyledImage = styled.img`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 171px;
  object-fit: cover;
  background-color: ${cssThemedValue({ light: colors.pepper8, dark: colors.salt12 })};
`;

const ImgPlaceholder = styled.img`
  width: 100%;
  height: 171px;
  object-fit: contain;
`;

const StyledHeartIcon = styled(HeartIcon)`
  position: absolute;
  top: 16px;
  right: 16px;
  flex-shrink: 0;
`;

const StyledContentWrapper = styled.div`
  padding: 12px 16px;
`;

const StyledName = styled.span`
  ${typographyCss.Title1}
  font-weight: 700;
  color: ${cssThemedValue('textPrimary')};
`;

const StyledDescription = styled.div`
  display: flex;
  color: ${cssThemedValue('textPrimary')};

  > * + *::before {
    content: '·';
    position: relative;
    display: inline-block;
    margin: 0 4px;
  }
`;

const StyledParagraph = styled.p`
  ${typographyCss.Body3}
  text-align: start;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const AdvertisingLabel = styled.p`
  ${typographyCss.Body3}
  color: ${cssThemedValue('textSecondary')};
  text-align: start;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-shrink: 0;
`;

export const VenuePreviewCard = ({ name, description, imageUrl }: VenuePreviewCardProps) => {
  return (
    <StyledRoot>
      <ImageContainer>
        <StyledHeartIcon />
        {imageUrl ? <StyledImage src={imageUrl} alt={name} /> : <ImgPlaceholder src={YuhoPlaceholder} />}
      </ImageContainer>

      <StyledContentWrapper>
        <StyledName>{name}</StyledName>
        <StyledDescription>
          {description && <StyledParagraph>{description}</StyledParagraph>}
          <AdvertisingLabel>
            <FormattedMessage id="campaigns.sidebar-preview.ads.sponsored" />
          </AdvertisingLabel>
        </StyledDescription>
      </StyledContentWrapper>
    </StyledRoot>
  );
};
